import actionTypes from './actionTypes';

const initialState = {
	form: {

	},
	isFormValid: false,
	isUploading: false,
	uploadingFailed: false,
	authentication: {
		token: localStorage.getItem('token') || null,
	},
};

export default function cmsReducer(state = initialState, action) {
	switch (action.type) {
		case actionTypes.ADD_DOCUMENT:
		case actionTypes.UPDATE_DOCUMENT:
		case actionTypes.REMOVE_DOCUMENT:
		case actionTypes.ADD_PRODUCT:
		case actionTypes.UPDATE_PRODUCT:
		case actionTypes.REMOVE_PRODUCT:
		case actionTypes.ADD_PROJECT:
		case actionTypes.UPDATE_PROJECT:
		case actionTypes.REMOVE_PROJECT:
		case actionTypes.ADD_REFERENCE:
		case actionTypes.UPDATE_REFERENCE:
		case actionTypes.REMOVE_REFERENCE:
		case actionTypes.ADD_USER:
		case actionTypes.UPDATE_USER:
		case actionTypes.REMOVE_USER:
		case actionTypes.ADD_FAQ:
		case actionTypes.UPDATE_FAQ:
		case actionTypes.REMOVE_FAQ:
		case actionTypes.UPLOAD_PO_FILE:
		case actionTypes.DOWNLOAD_PO_FILE:
		case actionTypes.LOG_IN:
		case actionTypes.LOG_OUT:
			return {
				...state,
			};
		case actionTypes.UPLOADING_FAILED:
			return {
				...state,
				isUploading: false,
				uploadingFailed: true,
			};
		case actionTypes.UPLOADING_SUCCEEDED:
			return {
				...state,
				isUploading: false,
				uploadingFailed: false,
			};
		case actionTypes.UPLOADING_IN_PROGRESS:
			return {
				...state,
				isUploading: true,
				uploadingFailed: false,
			};
		case actionTypes.VALIDATE_FORM:
			return {
				...state,
				isFormValid: action.valid,
			};
		case actionTypes.UPDATE_FORM:
			return {
				...state,
				form: {
					...state.form,
					[action.key]: {
						...state.form[action.key],
						...action.value,
					},
				},
			};
		case actionTypes.INIT_FORM:
			return {
				...state,
				form: {
					...action.form,
				},
			};
		case actionTypes.SET_TOKEN:
			return {
				...state,
				authentication: {
					...state.authentication,
					token: action.token,
				},
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/cms/cmsReducer.js